<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客户列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                 <!-- 日期 -->
                <a-range-picker :locale="locale" @change="ondateChange" placeholder="请选择日期范围" style="margin-right:12px"/>

                <!-- 标签 -->
                <!-- <a-select style="width: 120px" allowClear @change="zfhandleChange" placeholder="支付状态" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in zfoption" :key="x" :value="option.id">
                        {{option.title}}
                    </a-select-option>
                </a-select>
                <a-select style="width: 120px" allowClear @change="typehandleChange" placeholder="物流状态" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in typeoption" :key="x" :value="option.id">
                        {{option.title}}
                    </a-select-option>
                </a-select>
                <a-select style="width: 120px" allowClear @change="jhhandleChange" placeholder="激活状态" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in jhoption" :key="x" :value="option.id">
                        {{option.title}}
                    </a-select-option>
                </a-select> -->

                <a-button type="primary" @click="moreTel">快拨</a-button>

                <a-button type="danger" @click="delusers" >删除数据</a-button>
            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    placeholder="关键字（名称/手机）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="usid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'customdetail',query: {id:record.id}}" >
                        {{ text }}
                    </router-link>

                     <span slot="status" slot-scope="text">
                        <a-tag v-if="text=='未发货'" color="orange">{{text}}</a-tag>
                        <a-tag v-if="text=='已发货'" color="green">{{text}}</a-tag>
                        <a-tag v-if="text=='已签收'" color="blue">{{text}}</a-tag>
                        <a-tag v-if="text=='已激活'" color="green">{{text}}</a-tag>
                    </span>

                    <span slot="pay" slot-scope="text">
                        <a-tag v-if="text==0" color="orange">未支付</a-tag>
                        <a-tag v-if="text==1" color="green">已支付</a-tag>
                        <a-tag v-if="text==3" color="blue">已退款</a-tag>
                    </span>

                    <span slot="jh" slot-scope="text">
                        <a-tag v-if="text=='未激活'" color="orange">{{text}}</a-tag>
                        <a-tag v-if="text=='已激活'" color="green">{{text}}</a-tag>
                    </span>

                    <span slot="sources" slot-scope="text">
                      <span v-if="text==1">电话</span>
                      <span v-if="text==2">百度</span>
                    </span>
                    <span slot="sex" slot-scope="text">
                      <span v-if="text==1">男</span>
                      <span v-if="text==2">女</span>
                    </span>
                     <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <span slot="address" slot-scope="text,record">
                        {{record.province}}{{record.city}}{{record.area}}{{text}}
                    </span>
                    
                    <a style="color:#1890ff;display:flex;align-items: center;" slot="phone" slot-scope="text,record" @click="totel(record.usxsid,record.telephone)">
                        <a-icon type="phone" theme="filled"/> 
                        <span v-if="pwdtype==1" style="margin-left:3px">{{text}}</span> 
                        <span v-if="pwdtype==2" style="margin-left:3px">{{text | topwd}}</span>
                        <span v-if="pwdtype==3" style="margin-left:3px">{{text | tomd5}}</span>
                    </a>
                    <span slot="action" slot-scope="text,record">
                        <a href="javascript:;" @click="tobusiness(record.usid)" ><a-icon type="check-circle" /> 签约</a>


                        <a href="javascript:;" @click="tokehu(record.usid,record.aid)" ><a-icon type="edit" /> 跟进</a>

                        <!-- <a href="javascript:;"  @click="copy($event,record.invitationlink)" style="margin-right:12px"><a-icon type="copy" /> 复制链接</a> -->
                        <router-link :to="{path:'customdetail',query: {id:record.usid,kid:record.usid}}"><a-icon type="profile"/> 详情</router-link>
                    </span>
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 编辑 -->
        <a-modal
        title="客户跟进"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="khhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="线索操作">
                    <a-radio-group name="radioGroup" v-model="cluedetail.isvalid" @change="ontypeChange">
                        <a-radio :value="0">
                        客户跟进
                        </a-radio>
                        <a-radio :value="2">
                        无效客户
                        </a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item label="跟进状态" v-if="numshow1">
                    <a-radio-group name="radioGroup"  @change="onstatusChange">
                        <a-radio :value="item.isvalid" v-for="item in statuslist" :key="item.isvalid">
                        {{item.title}}
                        </a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item label="回访时间" v-if="numshow1">
                    <a-date-picker :locale="locale" @change="onhfChange" placeholder="请选择回访时间"/>
                </a-form-item>
                

                
                <a-form-item label="姓名">
                    <a-input v-model="cluedetail.username" placeholder="请输入客户姓名"/>
                </a-form-item>
                <a-form-item label="电话">
                    <a-input v-model="cluedetail.telephone" placeholder="请输入客户电话"/>
                </a-form-item>
                <a-form-item label="地址">
                    <div style="dispaly:flex;justify-content: space-around;">
                        <!-- <a-cascader v-model="cluedetail.dz"  :field-names="{ label: 'name', value: 'name', children: 'area' }" @change="onaddressChange" :options="adddata" placeholder="请选择省、市、区"  /> -->
                        <v-distpicker :province="cluedetail.province" :city="cluedetail.city" :area="cluedetail.area" @selected="onaddressChange"></v-distpicker>
                    </div>
                   
                    <a-input v-model="cluedetail.address" placeholder="请输入详细地址"/>
                </a-form-item>
                <a-form-item label="性别">
                    <a-radio-group name="radioGroup" @change="cluedetail.sexSelectChange">
                        <a-radio :value="1">
                        男
                        </a-radio>
                        <a-radio :value="2">
                        女
                        </a-radio>
                    </a-radio-group>

                </a-form-item>

                <a-form-item label="备注">
                    <a-textarea v-model="cluedetail.remarks" placeholder="备注" :rows="4" />
                </a-form-item>
            </a-form>
        </a-modal>


         <!-- 签约 -->
        <a-modal
        title="客户签约"
        :visible="businessvisible"
        cancelText="取消"
        okText="确认"
        @ok="qyhandleOk"
        @cancel="qyhandleCancel"
        >
           <div style="height:400px;overflow-y:auto">
                 <a-form class="dataform" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="签约标题">
                    <a-input placeholder="签约标题" v-model="title"></a-input>
                </a-form-item>
                <a-form-item label="签约内容">
                    <a-textarea placeholder="签约内容" v-model="content" :rows="4"></a-textarea>
                </a-form-item>
                <a-form-item label="合同">
                     <a-upload
                        name="file"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        action="/api/wechat/addimg"
                        @change="hthandleChange"
                        :headers="headers"
                    >
                        <img v-if="contract" :src="contract" alt="avatar" />
                        <div v-else>
                            <!-- <a-icon :type="loading ? 'loading' : 'plus'" /> -->
                            <div class="ant-upload-text">上传</div>
                        </div>
                    </a-upload>
                </a-form-item>
                <a-form-item label="凭证">
                     <a-upload
                        name="file"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        action="/api/wechat/addimg"
                        @change="pzhandleChange"
                        :headers="headers"
                    >
                        <img v-if="voucher" :src="voucher" alt="avatar" />
                        <div v-else>
                            <!-- <a-icon :type="loading ? 'loading' : 'plus'" /> -->
                            <div class="ant-upload-text">上传</div>
                        </div>
                    </a-upload>
                </a-form-item>
                <a-form-item label="资质">
                     <a-upload
                        name="file"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        action="/api/wechat/addimg"
                        @change="zzhandleChange"
                        :headers="headers"
                    >
                        <img v-if="qualifications" :src="qualifications" alt="avatar" />
                        <div v-else>
                            <!-- <a-icon :type="loading ? 'loading' : 'plus'" /> -->
                            <div class="ant-upload-text">上传</div>
                        </div>
                    </a-upload>
                </a-form-item>

                <a-form-item label="签约备注">
                    <a-textarea v-model="remarks" placeholder="签约备注" :rows="4"></a-textarea>
                </a-form-item>


              
            </a-form>
           </div>
          
        </a-modal>

    </div>
    
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import Clipboard from 'Clipboard' 
import moment from 'moment'
import md5 from 'js-md5'
import { Modal } from 'ant-design-vue';

const columns = [
    {title: 'ID',dataIndex: 'usid',key: 'usid',fixed: 'left',width:80},
    {title: '姓名',dataIndex: 'username',key: 'username',scopedSlots: { customRender: 'name' },width:120},
    {title: '电话',dataIndex: 'telephone',key: 'telephone',scopedSlots: { customRender: 'phone' },width:'160px'},
    // {title: '地址',dataIndex: 'address',key: 'address',scopedSlots: { customRender: 'address' }},
    {title: '线索来源',dataIndex: 'sources',key: 'sources',scopedSlots: { customRender: 'sources' },width:120},
    // {title: '付款状态',dataIndex: 'state_pay',key: 'state_pay',scopedSlots: { customRender: 'pay' },width:100},
    
    // {title: '物流状态',dataIndex: 'state_wl',key: 'state_wl',scopedSlots: { customRender: 'status' },width:100},
    // {title: '激活状态',dataIndex: 'state_jh',key: 'state_jh',scopedSlots: { customRender: 'jh' },width:100},
    {title: '性别',dataIndex: 'sex',key: 'sex',scopedSlots: { customRender: 'sex' },width:90},
    // {title: '出生日期',dataIndex: 'birthday',key: 'birthday',scopedSlots: { customRender: 'date' }},
    {title: '备注',dataIndex: 'remarks',key: 'remarks',width:360},
    {title: '跟进时间',dataIndex: 'updatetime',key: 'updatetime',scopedSlots: { customRender: 'date' },width:120},

    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },fixed: 'right',width:180},
];
export default {
     filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        console.log(new Date(time))
        return formatDate (date, 'yyyy-MM-dd')
      },
      topwd (value) {
            const start = value.slice(0, 3)
            const end = value.slice(-4)
            return `${start}****${end}`
        },
        tomd5(value){
            const text=md5(value)
            const text2=text.slice(0,10);
            return text2
        }
    },
    data(){
        return{
            locale,
            show:true,
            zfoption:[{title:"全部",id:""},{title:"未支付",id:"0"},{title:"已支付",id:"1"},{title:"已退款",id:"3"}],
            jhoption:[{title:"全部",id:""},{title:"已激活",id:"1"},{title:"未激活",id:"2"}],
            typeoption:[{title:"全部",id:""},{title:"未发货",id:"0"},{title:"已发货",id:"1"},{title:"已签收",id:"2"},{title:"拒收",id:"3"}],
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tablex:"100%",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:[],
            pagination:{
                total:20
            },
            totalpage:2,
            size:10,
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],

            editvisible:false,

            form: this.$form.createForm(this, { name: 'coordinated' }),

            starttime:"",
            endtime:"",

            pwdtype:"",

            state_pay:"",
            state_jh:"",
            state_wl:"",

            selectedRowKeys: [],
            morecallnum:"",
            currentcallnum:0,


            numshow:true,
            numshow1:false,
            cluedetail:"",
            usxsid:"",
            aid:"",
            statusid:"",
            isvalid:0,

            headers:{"token":localStorage.getItem('token')},
            businessvisible:false,
            contractid:"",
            title:"",
            content:"",
            contract:"",
            voucher:"",
            qualifications:"",
            remarks:""
        }
    },
    mounted(){
        this.fetch()
        this.pwdtype=localStorage.getItem('pwdtype')
    },
    methods:{

           // 删除
        delusers(){
            if(this.selectedRowKeys.length==0){
                this.$message.error("请选择数据");
            }{
                var id=this.selectedRowKeys.join(",")
                Modal.confirm({
                    title: '提示',
                    content: '您确定删除吗?',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk:() => {
                        this.handok(id)
                    },
                    onCancel() {

                    },
                });
            }
           
        },
        handok(value){
            this.$axios.post('/api/user/deluser',{
                usids:value
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('删除成功');
                    // this.disabled=true
                    this.selectedRowKeys=[]
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 合同、凭证、资质图片上传
        hthandleChange(info){
            // console.log("1111")
            // console.log(info.file.response.data.url)
            this.contract=info.file.response.data.url
        },
        pzhandleChange(info){
            this.voucher=info.file.response.data.url
        },
        zzhandleChange(info){
            this.qualifications=info.file.response.data.url
        },

        // 签约
        tobusiness(id){
           
            this.businessvisible=true
            this.contractid=id
        },
        qyhandleOk(){
            //  console.log("id="+this.contractid)
            this.$axios.post('/api/user/addcontract',{
                usid:this.contractid,
                title:this.title,
                content:this.content,
                contract:this.contract,
                voucher:this.voucher,
                qualifications:this.qualifications,
                remarks:this.remarks
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.businessvisible=false
                    this.$message.success(res.data.msg);
                    this.title="",
                    this.content="",
                    this.contract="",
                    this.voucher="",
                    this.qualifications="",
                    this.remarks=""
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        qyhandleCancel(){
            this.businessvisible=false
        },



          // 回访时间
        onhfChange(date, dateString) {
            // console.log(date, dateString);
            this.revisitdays=moment(dateString).unix()
        },

        // 客户跟进
        // 状态跟进
        onstatusChange(e){
            this.statusid=e.target.value
        },
         ontypeChange(e) {
            // console.log(e.target.value)
            this.cluedetail.isvalid=e.target.value
            if( e.target.value==1||e.target.value==2){
                this.numshow=true
                this.numshow1=false
            }else if( e.target.value==0){
                this.numshow=false
                this.numshow1=true
            }
        },
        // 省市区选择
        onaddressChange(value){
            this.province=value[0]
            this.city=value[1]
            this.area=value[2]
        },
        tokehu(id,aid){
            this.editvisible=true
            this.usxsid=id
            this.getdetail()
            this.aid=aid
        },
        handleCancel(){
            this.editvisible=false
            this.moreTel()
        },
        khhandleOk(){
            this.$axios.post('/api/user/edituser',{
                usid:this.usxsid, 
                province:this.cluedetail.province,
                city:this.cluedetail.city,
                area:this.cluedetail.area,
                isvalid:this.statusid,
                username:this.cluedetail.username,
                telephone:this.cluedetail.telephone,
                address:this.cluedetail.address,
                sex:this.cluedetail.sex,
                birthday:this.birthday,
                remarks:this.cluedetail.remarks,
                isuser:this.cluedetail.isvalid,
                revisitdays:this.revisitdays
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=false
                    this.revisitdays=""
                    this.isvalid=0
                    this.fetch()
                    this.moreTel()
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },

        // 客户详情
        getdetail(){
            this.$axios.post('/api/user/userpage',{
                usid:this.usxsid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data
                     if(this.cluedetail.isvalid==""){
                        this.cluedetail.isvalid=0
                    }
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 多选框
        onSelectChange(selectedRows){
            console.log(selectedRows)
            this.selectedRowKeys = selectedRows;
        },
        // 快拨
        moreTel(){
            if(this.selectedRowKeys.length==0){
                // this.$message.warning("请选择数据"); 
            }else if(this.selectedRowKeys.length>0){
                this.morecallnum=this.selectedRowKeys.length
                this.$message.success("快拨开始"); 
                var num=this.currentcallnum
                if(num+1>this.morecallnum){
                    this.selectedRowKeys=[]
                    this.currentcallnum=0
                    this.$message.warning("快拨结束"); 
                }else{
                    this.$axios.post('/api/user/userpage',{
                        usxsid:this.selectedRowKeys[num]
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            
                            sendMsg("changesim")
                            // zhihu(res.data.data.telephone)
                            var timer=setTimeout(()=>{
                                this.tokehu(this.selectedRowKeys[num],0)
                                clearTimeout(timer)
                            },2000)
                           
                            this.currentcallnum++

                            var phone=res.data.data.telephone
                            var id=this.selectedRowKeys[num]
                            if(localStorage.getItem('call_type')==0){
                                 this.$axios.post('/api/telephoneblack/verifytelephoneblack',{
                                    telephone:phone
                                },{
                                    headers: {
                                        "token":localStorage.getItem('token'),
                                    }  
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        zhihu(phone)
                                    }else{
                                        this.$message.error(res.data.msg);
                                    }
                                })
                            }else{
                                this.$axios.get('https://fxbkfluyin.13524.net/call_do.php?usxsid='+id,{},{
                                    headers: {
                                        "token":localStorage.getItem('token'),
                                    },
                                }).then((res)=>{
                                    if(res.data.code==100){
                                        this.$message.success(res.data.msg); 
                                    }else{
                                        this.$message.warning(res.data.msg); 
                                    }
                                })
                            }
                           
                        }else{
                            this.$message.warning(res.data.msg); 
                        }
                    
                    })
                }
            }
        },


        copy(e, text){
            const clipboard = new Clipboard(e.target, { text: () => text })
            clipboard.on('success', e => {
                this.$message.success('复制成功' )
                // 释放内存
                clipboard.off('error')
                clipboard.off('success')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                 this.$message.warning('该浏览器不支持自动复制' )
                // 释放内存
                clipboard.off('error')
                clipboard.off('success')
                clipboard.destroy()
            })
            clipboard.onClick(e)
        },
        // 来源筛选
        lyhandleChange(){

        },

        // 标签筛选
        zfhandleChange(value){
            this.currentpage=1
            this.state_pay=value
            this.fetch()

        },
        typehandleChange(value){
            this.state_wl=value
            this.currentpage=1
            this.fetch()

        },
        jhhandleChange(value){
            this.state_jh=value
            this.currentpage=1
            this.fetch()

        },

        // 号码查询
        handleserach(){

        },
        onSearch(){
            this.fetch()
        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(){
            this.$axios.post('/api/user/userlist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext,
                endtime:this.endtime,
                starttime:this.starttime,
                state_wl:this.state_wl,
                state_jh:this.state_jh,
                state_pay:this.state_pay

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.error(res.data.msg); 
                }
                
            })
        },

        // 外呼
        totel(id,phone){
           

            if(localStorage.getItem('call_type')==0){
                 sendMsg("changesim")
                this.$axios.post('/api/telephoneblack/verifytelephoneblack',{
                    telephone:phone
                },{
                    headers: {
                        "token":localStorage.getItem('token'),
                    }  
                }).then((res)=>{
                    if(res.data.code==200){
                        zhihu(phone)
                    }else{
                        this.$message.error(res.data.msg);
                    }
                })
                //  zhihu(phone)
                this.tokehu(id,aid)
            }else if(localStorage.getItem('call_type')==1){
                this.$axios.get('https://fxbkfluyin.13524.net/call_do.php?usxsid='+id,{},{
                    headers: {
                        "token":localStorage.getItem('token'),
                    },
                }).then((res)=>{
                    if(res.data.code==100){
                        this.$message.success(res.data.msg); 
                    }else{
                        this.$message.warning(res.data.msg); 
                    }
                })

                 this.tokehu(id,aid)
            }
           
        },
    
        ondateChange(date, dateString) {
            this.starttime=moment(dateString[0]+' 00:00:01').unix()
            this.endtime=moment(dateString[1]+' 23:59:59').unix()
            this.fetch()
        },


    }
}
</script>


// WEBPACK FOOTER //
// src/components/resources/customlist.vue